var _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationTeachersUnite = function SvgSimpleIllustrationTeachersUnite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "simple-illustration__teachers-unite_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".simple-illustration__teachers-unite_svg__st4{fill:none;stroke:#002140;stroke-linecap:round;stroke-linejoin:round}")), /*#__PURE__*/React.createElement("path", {
    d: "M25.6 12.8c1.5-2.7 2.9-3.9 6-3.9 2.9 0 5.7 2.4 5.7 5.6.1 3.1-1.6 5.2-4.3 6.6-2.9 1.9-4.4 4.2-6.2 6.9-.8 1.5-1.5 1.5-2.4 0-1.8-2.7-3.3-5-6.2-6.9-2.7-1.5-4.4-3.5-4.3-6.6 0-3.2 2.8-5.6 5.7-5.6 3.1 0 4.5 1.2 6 3.9z",
    style: {
      fill: "#f68dfe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.1 51.2 3.6-.1c-.1 3.1-.6 6-1.4 6.6-.1.1-.2.1-.3.1h-.1c-1.8-.2-1.8-4.2-1.8-6.6z",
    style: {
      fill: "#ffa75a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8 42c3.1 0 3.1 15.9 0 15.9h-8.5v-.1c.9-.6 1.3-3.4 1.4-6.6.1-4.3-.4-9.2-1.8-9.2h8.9z",
    style: {
      fill: "#fffaf0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 40.5-.1-.4c-.4-.5-.6-1.1-.6-1.7-.1-1.2.7-2.4 2.4-2.2 3.1.3 4.4 2 11.8 2.4l9.1-.4c4.3-.2 3.2-3.1 1-4.1-2.7-1.1-3.1-4.8-1.3-6.6 1.1-1.3 3.5-.6 3.7 1.2.7 2.1 2.6 3 5 3.5 4.2 1.1 6.2 4.9 6.8 9.8H53c1.3 0 1.9 4.9 1.8 9.2h-6.5c-4.6 4.1-11.6 6-20.9 3.4-4.9.9-9.5 1-13.9 0-1.8-.6-3.7-1.3-4.1-3.4-.2-.8.1-1.7.9-2.1-.8-.6-1.1-1.6-1.2-2.2-.1-1 .3-1.9 1.2-2.3-.6-.6-.9-1.4-.9-2-.1-.9.2-1.7 1.1-2.1z",
    style: {
      fill: "#03d47c"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2 42h13.3M41.4 32.2c4.2 1.1 6.2 4.9 6.8 9.8M36.4 28.7c.7 2.1 2.6 3 5 3.5M48.2 51.2h6.5M61.8 42c3.1 0 3.1 15.9 0 15.9M53.2 57.8h8.3M52.9 42c1.3 0 1.9 4.9 1.8 9.2-.1 3.1-.6 6-1.4 6.6-.1.1-.2.1-.3.1M51.1 51.2c0 2.3 0 6.3 1.8 6.6M27.4 54.5c9.3 2.6 16.3.7 20.9-3.4M33 38.1c4.3-.2 3.2-3.1 1-4.1M33.4 47.5c2.8-2.2 7.9-2.7 10.7-.3M34 34c-2.7-1.1-3.1-4.8-1.3-6.6",
    className: "simple-illustration__teachers-unite_svg__st4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 28.7c-.3-1.8-2.7-2.5-3.7-1.2M27.4 54.5c-4.9.9-9.5 1-13.9 0M24 50c-7.9.9-9.2-1.3-12.3-1.3M13.5 54.5c-1.8-.6-3.7-1.3-4.1-3.4",
    className: "simple-illustration__teachers-unite_svg__st4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 51.1c-.2-.8.1-1.7.9-2.1.3-.2.8-.3 1.4-.3M23.7 46.5c-7.9.4-9.1-1.8-12.2-2",
    className: "simple-illustration__teachers-unite_svg__st4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 49c-.8-.6-1.1-1.6-1.2-2.2M9.1 46.8c-.1-.9.3-1.8 1.2-2.2.3-.1.7-.2 1.1-.1M24 42.4c-7.9.3-9.1-1.9-12.2-2.1",
    className: "simple-illustration__teachers-unite_svg__st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 44.6c-.6-.6-.9-1.4-.9-2M9.4 42.6c-.1-.9.3-1.7 1.1-2.1.4-.2.8-.2 1.3-.2M24 38.6c-7.4-.4-8.7-2.1-11.8-2.4M10.3 40.1c-.4-.5-.6-1.1-.6-1.7",
    className: "simple-illustration__teachers-unite_svg__st4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 38.5c-.1-1.2.7-2.4 2.4-2.2M33 38.1l-9 .5M26.8 28c1.8-2.7 3.3-5 6.2-6.9M25.6 12.8c1.5-2.7 2.9-3.9 6-3.9M33 21.1c2.7-1.5 4.4-3.5 4.3-6.6M31.6 8.9c2.9 0 5.7 2.4 5.7 5.6M24.4 28c-1.8-2.7-3.3-5-6.2-6.9M25.6 12.8c-1.5-2.7-2.9-3.9-6-3.9M18.2 21.1c-2.7-1.5-4.4-3.5-4.3-6.6M19.6 8.9c-2.9 0-5.8 2.4-5.7 5.6M26.8 28c-.8 1.5-1.5 1.5-2.4 0",
    className: "simple-illustration__teachers-unite_svg__st4"
  })));
};
export default SvgSimpleIllustrationTeachersUnite;